import { DashboardMenu } from "../../data/menu"
import { useTranslation } from 'react-i18next';
import BreadCrump from "../tools/breadcrump"
import DashboardButton from "../Setting/dashboardButton";

export default function IndexTestimonial() {
    const { t } = useTranslation();

    const breadcrump = [
        {
            name: 'Dashboard',
            url: '/dashboard'
        },
        {
            name: 'Testimonial',
            url: null
        },
    ]
    return (
        <>
            <div className="text-left  bg-white  p-3 m-4   h-[100vh] mb-5 ">
                <BreadCrump data={breadcrump}></BreadCrump>
                <DashboardButton item="Testimonial" DashboardMenu={DashboardMenu}></DashboardButton>
            </div>
        </>
    )
}

